// ActivityTabs.jsx (continued)
import { LuCalendarDays, LuClock } from 'react-icons/lu';


export const ActivityLogsContent = ({ userDetails, logData }) => {
    return (
        <div className="p-4 md:p-6 bg-white h-screen">
            <div className="space-y-3">
                {logData && logData.length > 0 ?
                    logData.map((log) => (
                        <div key={log.id} className="px-6 py-4 rounded-lg border border-gray-300">
                            <h4 className="text-lg lg:text-xl font-medium textblack mb-3">{log.action}</h4>
                            <div className="flex flex-wrap items-center gap-6 text-gray-600">
                                <div className="flex items-center gap-2.5 text-indigo-600">
                                    <LuCalendarDays size={20} />
                                    <span>{log.date}</span>
                                </div>
                                <div className="w-px h-5 bg-indigo-600 hidden md:block"></div>
                                <div className="flex items-center gap-2.5 text-indigo-600">
                                    <LuClock size={20} />
                                    <span>{log.time}</span>
                                </div>
                            </div>
                        </div>
                    )) :
                    <>
                        <div className="flex items-center justify-center h-64">
                            <p className="text-gray-400 text-3xl">Logs not available!</p>
                        </div>
                    </>}
            </div>
        </div>
    );
};